"use strict";

exports.__esModule = true;
exports.unpackSDKMeta = unpackSDKMeta;

var _url = _interopRequireDefault(require("url"));

var _paypalSdkConstants = require("paypal-sdk-constants");

var _jsxPragmatic = require("jsx-pragmatic");

var _constants = require("./constants");

var _util = require("./util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function validatePaymentsSDKUrl({
  protocol,
  hostname,
  pathname,
  query,
  hash
}) {
  if (hostname === _constants.HOST.LOCALHOST) {
    if (protocol !== _constants.PROTOCOL.HTTP && protocol !== _constants.PROTOCOL.HTTPS) {
      throw new Error(`Expected protocol for sdk url to be ${_constants.PROTOCOL.HTTP} or ${_constants.PROTOCOL.HTTPS} for host: ${hostname} - got ${protocol || 'undefined'}`);
    }
  } else {
    if (protocol !== _constants.PROTOCOL.HTTPS) {
      throw new Error(`Expected protocol for sdk url to be ${_constants.PROTOCOL.HTTPS} for host: ${hostname} - got ${protocol || 'undefined'}`);
    }
  }

  if (pathname !== _paypalSdkConstants.SDK_PATH) {
    throw new Error(`Invalid path for sdk url: ${pathname || 'undefined'}`);
  } // $FlowFixMe


  for (const [key, val] of (0, _util.entries)(query)) {
    // $FlowFixMe
    if (!(0, _util.constHas)(_paypalSdkConstants.SDK_QUERY_KEYS, key)) {
      throw new Error(`Unexpected query key for sdk url: ${key}`);
    }

    if (!val) {
      throw new Error(`Unexpected empty query value for sdk url: ${key}`);
    }

    if (typeof val !== 'string') {
      throw new TypeError(`Unexpected non-string key for sdk url: ${key}`);
    }

    if (!val.match(/^[a-zA-Z0-9_,-]+$/)) {
      throw new Error(`Unexpected characters in query key for sdk url: ${key}=${val}`);
    }
  }

  if (hash) {
    throw new Error(`Expected no hash to be passed in sdk url, got ${hash}`);
  }
}

function validateLegacySDKUrl({
  pathname
}) {
  if (!pathname.match(_constants.LEGACY_SDK_PATH)) {
    throw new Error(`Invalid path for legacy sdk url: ${pathname || 'undefined'}`);
  }
}

function validateSDKUrl(sdkUrl) {
  const {
    protocol,
    hostname,
    pathname,
    query,
    hash
  } = _url.default.parse(sdkUrl, true);

  if (!hostname) {
    throw new Error(`Expected host to be passed for sdk url`);
  }

  if (!pathname) {
    throw new Error(`Expected pathname for sdk url`);
  }

  if (hostname.endsWith(_constants.HOST.PAYPAL)) {
    validatePaymentsSDKUrl({
      protocol,
      hostname,
      pathname,
      query,
      hash
    });
  } else if (hostname === _constants.HOST.PAYPALOBJECTS) {
    validateLegacySDKUrl({
      pathname
    });
  } else {
    throw new Error(`Expected host to be a subdomain of ${_constants.HOST.PAYPAL} or ${_constants.HOST.PAYPALOBJECTS}`);
  }
}

function validateHost(url) {
  const {
    hostname
  } = _url.default.parse(`https://${url}`, true);

  if (url !== hostname) {
    throw new Error(`Expected only host to be passed, got ${url}`);
  }

  if (!url.endsWith(_constants.HOST.PAYPAL)) {
    throw new Error(`Expected a paypal host`);
  }
}

function unpackSDKMeta(sdkMeta) {
  const {
    url,
    stageHost,
    apiStageHost
  } = sdkMeta ? JSON.parse(Buffer.from(sdkMeta, 'base64').toString('utf8')) : _constants.DEFAULT_SDK_META;

  if (url) {
    validateSDKUrl(url);
  }

  if (stageHost) {
    validateHost(stageHost);
  }

  if (apiStageHost) {
    validateHost(apiStageHost);
  }

  const getSDKLoader = ({
    baseURL = _constants.DEFAULT_LEGACY_SDK_BASE_URL,
    nonce = ''
  } = {}) => {
    if (url) {
      const attrs = {};

      if (stageHost) {
        attrs[_paypalSdkConstants.SDK_SETTINGS.STAGE_HOST] = stageHost;
      }

      if (apiStageHost) {
        attrs[_paypalSdkConstants.SDK_SETTINGS.API_STAGE_HOST] = apiStageHost;
      }

      return (0, _jsxPragmatic.node)("script", _extends({
        nonce: nonce,
        src: url
      }, attrs)).render((0, _jsxPragmatic.html)());
    }

    return (0, _jsxPragmatic.node)("script", {
      nonce: nonce,
      innerHTML: `
                    (function() {
                        if (!window.name || window.name.indexOf('xcomponent') !== 0) {
                            return;
                        }

                        var version = window.name.split('__')[2].replace(/_/g, '.');

                        if (!version.match(/^[0-9a-zA-Z.]+$/)) {
                            return;
                        }

                        if (version === '4' || version === 'latest') {
                            version = '';
                        }

                        var url = '${baseURL}checkout' + (version ? ('.' + version) : '') + '.js';

                        var scriptTag = '<scr' + 'ipt src="' + url + '" data-paypal-checkout data-no-bridge data-state="ppxo_checkout"></scr' + 'ipt>';
                        document.write(scriptTag);
                    })();
                `
    }).render((0, _jsxPragmatic.html)());
  };

  return {
    getSDKLoader
  };
}